import { Retail } from "../../components";

export const CategoriaRetail = () => <Retail />;
